import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { WalletContext, STAKING_CONTRACT_ID, TOKEN_CONTRACT_ID, MAX_GAS, NFT_CONTRACT_ID } from "../Wallet";
import * as nearAPI from "near-api-js";
const { utils: { format: {formatNearAmount}} } = nearAPI;

function Balance() {
  const { wallet, stakedNftList, plasmabalance, setplasmabalance } = useContext(WalletContext)
  const [claimBalance, setClaimBalance] = useState(0)
  const [totalStakedSupply, setTotalStakedSupply] = useState(0)
  const [totalNftSupply, setTotalNftSupply] = useState(0)

  const onClaim = async (wallet) => {
    if(wallet && wallet.isSignedIn()){
      let result;
      result = await wallet.account().functionCall({
        contractId: STAKING_CONTRACT_ID,
        methodName: "claim_reward",
        args: {
        },
        gas: MAX_GAS,
        attachedDeposit: "1",
      });
      updateState(wallet);
    }
  }

  const updateState = async (wallet) => {
    if(wallet && wallet.isSignedIn()){
      let result;
      result = await wallet.account().viewFunction(
        TOKEN_CONTRACT_ID,
        "ft_balance_of",
        {
          account_id: wallet.account().accountId,
        }
      ); 
      setplasmabalance(formatNearAmount(result));
      console.log("==============================", plasmabalance);

      result = await wallet.account().viewFunction(
        STAKING_CONTRACT_ID,
        "get_claim_amount",
        {
          account_id: wallet.account().accountId,
        }
      ); 
      setClaimBalance(formatNearAmount(result));

      result = await wallet.account().viewFunction(
        STAKING_CONTRACT_ID,
        "get_supply_staking_informations",
        {
        }
      ); 
      setTotalStakedSupply(result);

      result = await wallet.account().viewFunction(
        NFT_CONTRACT_ID,
        "nft_total_supply",
        {
        }
      ); 
      setTotalNftSupply(result);
    }
  }

  useEffect(() => {
    updateState(wallet);
  }, [wallet])

  return (
    <Row xs={1} lg={3}>
      <Col>
        <Container fluid className="p-0 balance-area">
          <div className="m-auto balance-area p-5 pt-4 pb-4 text-center">
            <Row xs={1} className="align-center info-box">
              <Col>
                <div className="info-container">
                  <h1>Overall Staked:</h1><h1>{totalStakedSupply}/{totalNftSupply} NFTs</h1>
                </div>
              </Col>
              <Col>
                <div className="info-container">
                  <h1>My Staked:</h1><h1>{stakedNftList.length} NFTs</h1>
                </div>
              </Col>
              <Col>
                <div className="info-container">
                  <h1>Daily Rewards:</h1><h1>{stakedNftList.length * 5} $PLASMA</h1>
                </div>
              </Col>
              <Col className="claim-container">
                <h1>Rewards: {claimBalance} $PLASMA</h1>
                <Button className="claim-btn" onClick={()=> onClaim(wallet)}><h1>Claim Reward</h1></Button>
              </Col>
            </Row>
          </div>
        </Container>
      </Col>
    </Row>
  );
}

export default Balance;
